import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '../../shared_components/UI/Box'

import {
  selectIsDarkThemeState,
} from '../../modules/miscUi/selectors'
import {
  setHeaderBgUrl,
  setShowHeaderGradient,
} from '../../modules/miscUi/actions'

import { Container } from './styles'
import { selectUser } from '../../modules/user/selectors'
import { useLocation } from 'react-router-dom'
import useIsLoggedIn from '../../hooks/useIsLoggedIn'
import AnimatedLoader from '../../shared_components/AnimatedLoader'
import styled from 'styled-components'

import { selectAccount } from '../../modules/web3/selectors'

import { useRefetchUpdateUser } from '../TwitterAuth'

import {
  H1,
  H2,
  Span,
  Strong,
} from '../../shared_components/Library/Typeography'
import { Card } from '../../shared_components/Library/Card'
import {
  Avatar,
  getUsernameFromUserObject,
} from '../DropDetails/DropOverview'
import useTwitterProfileImage from '../../hooks/useTwitterProfileImage'
import ConnectWalletButton from '../../shared_components/Library/Buttons/ConnectWalletButton'
import { FormBox, InputBox, InputLabel } from '../Memecoins/TokenLauncher/styles'
import { PoolInput } from '../PoolDetails/parts'
import { ThemedButton } from '../../shared_components/ThemedButton'
import { useEditProfileMutation } from '../../modules/user/api'
import { toast } from 'react-toastify'

const Profile = () => {
  const { isLoggedIn, isAuthenticating } = useIsLoggedIn()
  const isDarkTheme = useSelector(selectIsDarkThemeState)
  const [userName, setUserName] = useState('')

  const dispatch = useDispatch()

  const wallet = useSelector(selectAccount)

  useEffect(() => {
    dispatch(setHeaderBgUrl(`/hero-cover-labs.png`))
    dispatch(setShowHeaderGradient(false))
    return () => {
      dispatch(setHeaderBgUrl(''))
    }
  }, [isDarkTheme, dispatch])

  const user = useSelector(selectUser)

  const refetchUpdateUser = useRefetchUpdateUser()
  const location = useLocation()
  const [editProfileMutation, { isLoading }] = useEditProfileMutation()

  useEffect(() => {
    const hash = location.hash
    if (!hash) return

    const element = document.getElementById(hash.substring(1))

    if (!element) return

    element.scrollIntoView({ behavior: 'smooth' })
  }, [location])

  useEffect(() => {
    refetchUpdateUser()
  }, [])

  useEffect(() => {
    const username = getUsernameFromUserObject(user, wallet)

    setUserName(username ?? user.walletAddress)
  }, [user])

  const { url } = useTwitterProfileImage(user)

  const onSubmit = useCallback(async () => {
    if (!isLoggedIn) return
    
    try {
      await editProfileMutation({ userName })
      refetchUpdateUser()
      toast.success('Profile updated')
    } catch(e) {
      console.error(e)
      toast.error('Failed to update profile')
    }
  }, [refetchUpdateUser, userName])
  
  if (!isLoggedIn && !isAuthenticating) return <LogoutSelfDestruct />

  const handleChangeUserName = (e) => {
    setUserName(e.target.value)
  }

  return (
    <Box jc>
      <Box dc g={32} mw="628px">
        <H2 s="XL" fw="semibold" c="text-primary">
          Edit Profile
        </H2>
        {!user ?
          <ConnectWalletButton />
          : (
            <>
              <FormBox>
                <InputBox>
                <InputLabel htmlFor="userName">Display Name</InputLabel>
                <PoolInput
                  id="userName"
                  name="userName"
                  value={userName}
                  type="text"
                  onChange={handleChangeUserName}
                />
              </InputBox>
              {/* <Box dc g={16}>
                <ImageUploader
                  label={<InputLabel>Upload an image for your token</InputLabel>}
                  // subLabel='For best results use a square image, at least 800x800px, GIF, PNG or JPEG'
                  imageUrl={logoUrl}
                  setImageUrl={handleSetLogoUrl}
                  width="104"
                  height="104"
                />
                {errors.logoUrl && (
                  <ErrorMessage>An image is required</ErrorMessage>
                )}
              </Box> */}
              </FormBox>
              <Box
                jfs
              >
                <ThemedButton
                  onClick={onSubmit}
                  $styleType="primary"
                  disabled={isLoading}
                >
                  Save preferences
                </ThemedButton>
              </Box>
            </>
        )}
      </Box>
    </Box>
  )
}

export default Profile

const Outer = styled(Box)`
  min-height: 50vh;
`

function LogoutSelfDestruct() {
  useEffect(() => {
    let timer = setTimeout(() => {
      window.location.href = '/'
      timer = null
    }, 1000)
    return () => {
      clearTimeout(timer)
      timer = null
    }
  }, [])
  return (
    <Container>
      <Outer c>
        <AnimatedLoader onlyWhite />
      </Outer>
    </Container>
  )
}
